<template>
  <div
    :class="{ 'drop-files_drag-enter': dragEnter, 'drop-files_error': error, 'drop-files_small': small }"
    class="drop-files"
    @click="onDropFilesClick"
    @dragenter.prevent="onDragEnter"
    @dragleave.prevent="onDragLeave"
    @dragover.prevent="onDragOver"
    @drop.prevent="onDrop"
  >
    <input
      v-if="logoRemove && removeName"
      :name="removeName"
      style="display:none;"
      type="text"
      value="1"
    />
    <p class="drop-files__text text-caption-m">
      <i class="icon icon-upload drop-files__icon" />

      <span v-if="!small">{{ $t('drop_files_here') }}</span>
      <span>
        <i18n
          v-if="!small"
          path="or-i18n"
          tag="span"
        >
          <template #br>
            <br />
          </template>
          <template #or>
            {{ $t('or') }}
          </template>
        </i18n>
        <label
          ref="labelDrop"
          class="drop-files__label-to-drop"
        >
          <template v-if="!small">
            {{ $t('select_name') }} <span>{{ $t('from_device') }}</span>
          </template>
          <template v-else>
            {{ $t('select-small') }}
          </template>
          <input
            ref="input"
            :accept="accept"
            :multiple="multiple"
            :name="!crop ? name : '' "
            :required="required"
            type="file"
            @change="onInputChange"
          />
          <input
            v-if="crop"
            :name="name"
            :value="avatarBase64"
            type="hidden"
          />
        </label>
      </span>
    </p>
    <div
      id="output"
      class="container"
      style="display: none"
    />

    <div
      class="drop-files__drop-enter"
      style="display: none; pointer-events: none;"
    >
      <p class="drop-files__text-drop-enter text-body-m">
        {{ $t('drop_files_here') }}
      </p>
    </div>

    <div
      v-if="error"
      class="drop-files__error"
    >
      <p class="drop-files__error__title text-caption-m">
        <i class="icon icon-remove" />
        <span class="drop-files__name">
          &nbsp;(
        </span>
        <span class="drop-files__size">
          )
        </span>
      </p>
      <p class="drop-files__error__text text-caption-m">
        {{ errorText }}
      </p>
    </div>
    <img
      v-if="src"
      :src="src"
    />

    <div
      id="upload-logo"
      class="popup mfp-hide popup-completed"
    >
      <h2
        class="title-small"
        style="margin-bottom: 39px"
      >
        {{ $t('crop_image') }}
      </h2>
      <Cropper
        v-if="showCrop"
        :get-data-url="getDataUrl"
        :upload-image-src="uploadImageSrc"
        @dataUrl="onDataUrl"
      />
      <ButtonsBottom
        @cancelClick="onCancelClick"
        @submitClick="onSubmitClick"
      />
    </div>
  </div>
</template>

<script>
  import Cropper from './profile/Cropper.vue'
  import ButtonsBottom from './ButtonsBottom.vue'

  export default {
    name: 'DropImages',
    components: { ButtonsBottom, Cropper },
    props: {
      name: {
        required: true,
        type: String,
      },
      removeName: {
        default: '',
        type: String,
      },
      accept: {
        default: 'image/png, image/jpeg, image/tiff',
        type: String,
      },
      multiple: {
        default: true,
        type: Boolean,
      },
      logo: {
        default: '',
        type: [Array, String],
      },
      small: {
        type: Boolean,
        default: false,
      },
      height: {
        type: Number,
        default: 60,
      },
      crop: {
        type: Boolean,
        default: false,
      },
      openPopup: {
        type: String,
        default: '',
      },
      required: {
        type: Boolean,
        default: false,
      },
      maxFileSizeMb: {
        type: Number,
        default: 10,
      },
    },
    data: () => ({
      dragEnter: false,
      error: false,
      errorText: '',
      src: '',
      logoRemove: false,
      showCrop: false,
      uploadImageSrc: null,
      getDataUrl: false,
      avatarBase64: '',
    }),
    watch: {
      logo(val) {
        if (!val) {
          this.$refs.input.value = ''
        }
        this.logoRemove = !val
      },
      showCrop(val) {
        if (val) {
          const src = $('#upload-logo')
          $.magnificPopup.close()
          $.magnificPopup.open({
            items: {
              src,
            },
            type: 'inline',
            callbacks: {
              close: () => {
                this.showCrop = false
                this.getDataUrl = false
                this.$refs.input.value = ''
              },
            },
          })
        } else {
          $.magnificPopup.close()
          this.getDataUrl = false
          this.$refs.input.value = ''
          if (this.openPopup) {
            const src = $(this.openPopup)
            if (!src.length) return
            $.magnificPopup.open({
              items: {
                src,
              },
              type: 'inline',
            })
          }
        }
      },
    },
    methods: {
      onDropFilesClick(e) {
        if ($(e.target).closest(`.${this.$refs.labelDrop.classList[0]}`).length) return
        this.$refs.input.click()
      },
      onDragEnter() {
        this.dragEnter = true
      },
      onDragOver() {
      },
      onDragLeave() {
        this.dragEnter = false
      },
      onDrop(e) {
        const dt = e.dataTransfer
        const filesForInput = dt.files
        const files = Array.from(filesForInput)
        this.dragEnter = false
        let error = false

        files.forEach((file) => {
          if (file.size / 1024 / 1024 > this.maxFileSizeMb) {
            alert(`Слишком большой размер файла, не больше ${this.maxFileSizeMb} мб`)
            error = true
            return
          }
          if ((file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/tiff')
            && this.accept !== '*') {
            error = true
            alert('Неверный формат файла')
            return
          }
          this.$emit('fileInit', file)
        })
        if (error) return

        if (!files[0].type.includes('tiff') && !files[0].type.includes('jpeg')
        && !files[0].type.includes('png')) {
          this.$refs.input.files = filesForInput
          this.$emit('filesLoad', files)
          return
        }

        const img = new Image()
        img.addEventListener('load', (ev) => {
          const { width, height } = ev.target

          if (width < this.height || height < this.height) {
            alert('Неверное разрешение изображения')
          } else if (this.crop) {
            this.uploadImageSrc = img.src
            this.showCrop = true
          } else {
            this.$refs.input.files = filesForInput
            this.$emit('filesLoad', files)
          }
        })
        img.src = window.URL.createObjectURL(files[0])
      },
      onInputChange(e) {
        const curFiles = Array.from(e.target.files)
        if (curFiles.length === 0) {
          alert('No files currently selected for upload')
          return
        }
        if (curFiles[0].size / 1024 / 1024 > this.maxFileSizeMb) {
          alert(`Слишком большой размер файла, не больше ${this.maxFileSizeMb} мб`)
          return
        }
        if (curFiles[0].type === 'image/tiff') {
          this.$emit('filesLoad', curFiles)
          return
        }
        if (!curFiles[0].type.includes('tiff') && !curFiles[0].type.includes('jpeg')
          && !curFiles[0].type.includes('png')) {
          this.$emit('filesLoad', curFiles)
          return
        }
        this.$emit('fileInit', curFiles[0])
        const img = new Image()
        img.addEventListener('load', (ev) => {
          const { width, height } = ev.target

          if (width < this.height || height < this.height) {
            alert('Неверное разрешение изображения')
          } else if (this.crop) {
            this.uploadImageSrc = img.src
            this.showCrop = true
          } else {
            this.$emit('filesLoad', curFiles)
          }
        })
        img.src = window.URL.createObjectURL(curFiles[0])
      },
      onDataUrl(dataUrl) {
        this.avatarBase64 = dataUrl
        this.showCrop = false
        this.$emit('logoChange', dataUrl)
      },
      onSubmitClick(e) {
        e.preventDefault()
        this.getDataUrl = true
      },
      onCancelClick() {
        this.showCrop = false
      },
    },
  }
</script>
